import React, { FunctionComponent, Fragment } from 'react';
import { Typography } from '@rbx/ui';
import type { OpenCloudAPIObjectSchema, OpenCloudAPISchema } from '../../../utils/oasTypes';
import OpenCloudTypeReference from '../../sharedUI/components/OpenCloudTypeReference';
import OpenCloudApiTable from '../../main/components/OpenCloudApiTable';

export interface AttributeTableProps {
  schema: OpenCloudAPIObjectSchema;
}

const AttributeTable: FunctionComponent<React.PropsWithChildren<AttributeTableProps>> = ({
  schema,
}) => {
  const { type, properties } = schema;
  if (type && type !== 'object') {
    return (
      <Typography>
        <OpenCloudTypeReference type={type} />
        {'enum' in schema && (
          <Fragment>
            {' '}
            {/** Not translating "enum" - maybe this will be a link */}
            (enum):{' '}
            <Typography variant='code' display='inline'>
              {schema.enum?.map((enumObj) => `"${enumObj}"`).join(', ')}
            </Typography>
          </Fragment>
        )}
      </Typography>
    );
  }

  if (typeof properties === 'undefined') {
    throw new Error('object has no properties');
  }

  return (
    <OpenCloudApiTable
      data={Object.entries(properties)
        /**
         * Technically any "Reference Object" should already be inlined by the
         * parser here, adding this purely for defensive purpose & help with
         * typing
         */
        .filter((propertyEntry): propertyEntry is [string, NonNullable<OpenCloudAPISchema>] => {
          const [, propertySchema] = propertyEntry;
          return !('$ref' in propertySchema);
        })}
    />
  );
};

export default AttributeTable;
